import agency from './agency';
import cart from './cart';
import listings from './listings';
import user from './user';
import reports from './reports';
import quotaCredits from './quotaCredits';
import leads from './leads';
import { TENANT_KEY } from '../../../utility/env';

const bayutTransformers = Object.freeze({
  key: TENANT_KEY,
  ...agency,
  ...cart,
  ...listings,
  ...user,
  ...quotaCredits,
  ...reports,
  ...leads,
});

export default bayutTransformers;
